import Vue from "vue";
import VueApollo from "vue-apollo";
import { createApolloClient } from "vue-cli-plugin-apollo/graphql-client";
import Store from "./store";
import Router from "./router";

Vue.use(VueApollo);

// Call this in the Vue app file
export function createProvider(options = {}) {
  // Create apollo client
  const { apolloClient } = createApolloClient({
    ...options,
    wsEndpoint: null,
    websocketsOnly: false,
    ssr: false,
    httpLinkOptions: {
      uri: process.env.VUE_APP_GRAPHQL_HTTP
    },
    getAuth() {
      const token = Store.getters["app/token"];
      return token ? `Bearer ${token}` : "";
    }
  });

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      }
    },
    async errorHandler(error) {
      await Store.dispatch("errors/add", { error });
      Router.push({ name: "error" });
    }
  });

  return apolloProvider;
}
